export default __webpack_public_path__ + "static/media/280.725998c2.svg";